import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;
const BACKEND_URL = "https://api.task-board.uz/";
const token = localStorage.getItem("token");

const echo = new Echo({
  broadcaster: "pusher",
  key: "4ad8047e613f7f71be70",
  cluster: "ap2",
  forceTLS: true,

  authEndpoint: `${BACKEND_URL}/api/broadcasting/auth`,
  auth: {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  },
});

export default echo;